import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {PrlAuthenticationService} from './prl-authentication.service';
import {switchMap} from 'rxjs/operators';
import {of} from 'rxjs';

export const unauthorizedGuard: CanActivateFn = (route, state) => {

    const authService = inject(PrlAuthenticationService);
    const router = inject(Router);
    if (authService.isForceResetRequired()) {
        if (state.url.startsWith('/force-reset-password')) {
            return true;
        }
        router.navigate(['/force-reset-password']);
        return false;
    }

    return authService.getAuthenticationObsr()
        .pipe(
            switchMap(value => {
                return of(!value);
            })
        );

};
